export default __webpack_public_path__ + "static/media/img_mobile_affliate_bg1.6dfd55b7.png";